jQuery(function($) {
    // Guard: do nothing if SEB settings are not present
    if ( typeof window.seb_commerce_payment_method_settings === 'undefined' || !window.seb_commerce_payment_method_settings ) {
        return;
    }


    // Guard: prevent double-initialization if script is loaded twice
    if ( window.__vetfondsSebSdkInitialized ) {
        return;
    }
    window.__vetfondsSebSdkInitialized = true;

    let paymentElement;
    const data = window.seb_commerce_payment_method_settings;
    let formData = {};

    // Mutex to prevent double submit / double payment creation
    let isSubmitting = false;

    // Checkout page
    $( document.body ).on(
        'updated_checkout',
        function () {
            let newFormData = get_form_data();
            if ( newFormData.billingCountry !== formData.billingCountry || newFormData.amount !== formData.amount ) {
                $( '#seb_commercePaymentElement' ).html( '' );
            }

            formData = newFormData;

            if ( $( '#seb_commercePaymentElement' ).is( ':empty' ) ) {
                load_sdk();
            } else {
                return;
            }
        }
    );

    // Checkout reload SDK on email change
    if ( window.wc_checkout_params && '1' === window.wc_checkout_params.is_checkout ) {
        $( '#billing_email' ).on( 'focusout', function() {
            let newFormData = get_form_data();
            if ( newFormData.email && newFormData.email !== formData.email && validate_email( newFormData.email ) ) {
                $( '#seb_commercePaymentElement' ).html( '' );

                load_sdk();
            }

            formData = newFormData;
        } );
    }

    // Order Pay SDK load
    if ( $( document.body ).hasClass( 'woocommerce-order-pay' ) ) {
        $( document ).ready( function() {
            if ( $( '#seb_commercePaymentElement' ).length > 0 ) {
                load_sdk();
            }
        } );
    }

    // Order Pay form submit
    $( document ).on( 'submit', 'form#order_review', async function ( e ) {
        if ( $( '#seb_commercePaymentElement:visible' ).length > 0 ) {
            $( '#order_review' ).unblock();
            e.preventDefault();

            // Guard: show missing payment method immediately on submit
            if ( ! get_selected_payment_method() ) {
                submit_error('<ul class="woocommerce-error" role="alert"><li>' + 'Lūdzu izvēlieties apmaksas veidu.' + '</li></ul>');
                return false;
            }

            await send_one_off_request( data.order_id, { is_order_pay: true } );

            return false;
        }
    } );

    function load_sdk() {
        const everyPay = new window.EveryPay({
            account: data.account,
            username: data.username,
        });

        const stylingOptions = Object.freeze({
            theme: data.theme,
            layout: data.layout,
        });

        const secureElementOptions = Object.freeze({
            stylingOptions: stylingOptions,
            amount: parseFloat( get_amount() ),
            email: $( '#billing_email' ).val(),
            environment: data.environment,
            locale: data.locale,
            preferredCountry: data.preferred_country ? data.preferred_country : $( '#billing_country' ).val(),
            username: data.username,
        });

        const paymentElementOptions = Object.freeze({
            element: 'payment',
        });

        paymentElement = everyPay
            .secureElements(secureElementOptions)
            .build(paymentElementOptions);

        paymentElement
            .mount('#seb_commercePaymentElement')
            .catch(function onPaymentElementMountError(err) {
                console.error(err);
            });
    }

    async function send_one_off_request( order_id, additional_data = {} ) {
        const submitResponse = await paymentElement.submit();
        if (submitResponse.error) {
            var msg = submitResponse.error.message ? submitResponse.error.message : 'Lūdzu aizpildiet apmaksas datus.';
            submit_error('<ul class="woocommerce-error" role="alert"><li>' + msg + '</li></ul>');
            isSubmitting = false;
            return false;
        }

        const method = paymentElement.selectedPaymentMethod ? paymentElement.selectedPaymentMethod() : null;
        if ( ! method ) {
            submit_error('<ul class="woocommerce-error" role="alert"><li>' + 'Lūdzu izvēlieties apmaksas veidu.' + '</li></ul>');
            isSubmitting = false;
            return false;
        }

        $.ajax({
            url: data.one_off_url,
            data: {
                'payment_method': method,
                'order_id': order_id,
                'is_order_pay': additional_data.is_order_pay ? additional_data.is_order_pay: false,
            },
            method: 'POST',
            async: false,
            success: function( resp ) {
                if ( ! resp.error ) {
                    paymentElement.confirm( resp.data );
                } else {
                    submit_error( resp.data.message );
                    isSubmitting = false;
                }
            },
            error: function () {
                submit_error('<div class="woocommerce-error">' + wc_checkout_params.i18n_checkout_error + '</div>');
                isSubmitting = false;
            }
        });
    }

    function get_amount() {
        const amountElement = document.querySelector( '.order-total .woocommerce-Price-amount' );
        if ( amountElement ) {
            const rawText = amountElement.innerText;
            return rawText.replace(/[^0-9.,]/g, '').replace(',', '.');
        } else {
            return data.amount;
        }
    }

    function get_form_data() {
        return {
            billingCountry: $( '#billing_country' ).val(),
            email: $( '#billing_email' ).val(),
            amount: get_amount(),
        };
    }

    var form_checkout = $('form.checkout');

    // IMPORTANT: namespace the event and unbind first, to avoid duplicate handlers
    form_checkout.off('checkout_place_order_seb_commerce_sdk.vetfondsSeb');

    form_checkout.on('checkout_place_order_seb_commerce_sdk.vetfondsSeb', async function() {
        // Hard stop: if we already started a submit flow, ignore duplicates
        if (isSubmitting) {
            return false;
        }

        // Missing payment method message on submit
        const selectedMethodNow =
            paymentElement && typeof paymentElement.selectedPaymentMethod === 'function'
                ? paymentElement.selectedPaymentMethod()
                : null;

        if ( ! selectedMethodNow ) {
            submit_error('<ul class="woocommerce-error" role="alert"><li>' + 'Lūdzu izvēlieties apmaksas veidu.' + '</li></ul>');
            return false;
        }

        isSubmitting = true;
        blockOnSubmit( form_checkout );

        try {
            var order_id = false;

            $.ajax({
                url: wc_checkout_params.checkout_url,
                dataType: "json",
                data: $('form.checkout').serialize(),
                method: "POST",
                async: false,
                success: function (result) {
                    if (result.order_id) {
                        form_checkout.removeClass('processing').unblock();
                        order_id = result.order_id;
                    } else if (result.messages) {
                        submit_error(result.messages);
                    } else {
                        submit_error('<div class="woocommerce-error">' + wc_checkout_params.i18n_checkout_error + '</div>');
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    submit_error('<div class="woocommerce-error">' + errorThrown + '</div>');
                }
            });

            if ( order_id ) {
                await send_one_off_request( order_id );
            } else {
                // If order creation failed, allow retry
                isSubmitting = false;
            }
        } catch (e) {
            console.error(e);
            submit_error('<div class="woocommerce-error">' + wc_checkout_params.i18n_checkout_error + '</div>');
            isSubmitting = false;
        }

        return false;
    });

    form_checkout.on( 'checkout_place_order_seb_commerce_sdk', function() {
        return false;
    });

    function blockOnSubmit( $form ) {
        var isBlocked = $form.data( 'blockUI.isBlocked' );

        if ( 1 !== isBlocked ) {
            $form.block({
                message: null,
                overlayCSS: {
                    background: '#fff',
                    opacity: 0.6
                }
            });
        }
    }

    function submit_error( error_message ) {
        $( '.woocommerce-NoticeGroup-checkout, .woocommerce-error, .woocommerce-message' ).remove();
        form_checkout.prepend( '<div class="woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout">' + error_message + '</div>' );
        form_checkout.removeClass( 'processing' ).unblock();
        $( '#order_review' ).removeClass( 'processing' ).unblock();

        // Allow retry after any error
        isSubmitting = false;

        scroll_to_notices();
        $( document.body ).trigger( 'checkout_error' , [ error_message ] );
    }

    function scroll_to_notices() {
        var scrollElement = $( '.woocommerce-NoticeGroup-updateOrderReview, .woocommerce-NoticeGroup-checkout' );

        if ( ! scrollElement.length ) {
            scrollElement = form_checkout;
        }
        $.scroll_to_notices( scrollElement );
    }

    function validate_email( email ) {
        return String( email )
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    }
});